import { render, staticRenderFns } from "./DasboardStatsTotal.vue?vue&type=template&id=76e77245&"
import script from "./DasboardStatsTotal.vue?vue&type=script&lang=js&"
export * from "./DasboardStatsTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports